import stringExcerpt from '../string/excerpt'
import strip from './strip'

export default function excerpt (html, max = 120) {
    const stripped = strip(html)
    return stringExcerpt(stripped, max)
}